var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v("\n    "+_vm._s(_vm.$t(_vm.label))+"\n    "),_c('v-chip',{attrs:{"color":"success","label":"","small":""}},[_vm._v(_vm._s(_vm.ratingObject.rating))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }